import React from 'react';

import { Box, BoxProps, Button, Code, Flex, ScrollArea, Text } from '@mantine/core';
import { JsonSchema } from 'pages/ManageSmartAssistant/Sections/ToolsSection/ToolConfigurationPanels/CustomApiRequestToolConfigurationPanel/JsonSchemaBuilder/types';
import { useTranslation } from 'react-i18next';
import { NotificationService } from 'services/notification-service';

interface JsonPreviewPanelProps extends BoxProps {
  schema: JsonSchema;
}

export function JsonPreviewPanel({ schema, ...props }: JsonPreviewPanelProps) {
  const { t } = useTranslation();
  const schemaJsonString = JSON.stringify(schema, null, 2);

  const handleCopySchema = () => {
    navigator.clipboard.writeText(schemaJsonString);
    NotificationService.showResult(true, t('JSON_SCHEMA_BUILDER.JSON_SCHEMA_COPIED'));
  };

  return (
    <Box {...props}>
      <Box
        p="md"
        sx={(theme) => ({
          border: `1px solid ${theme.other.gray.border}`,
          borderRadius: theme.defaultRadius,
          backgroundColor: 'white',
          minHeight: '120px',
          display: 'flex',
          flexDirection: 'column'
        })}>
        <Flex justify="space-between" align="center" mb="md">
          <Text fw={500} size="sm">
            {t('JSON_SCHEMA_BUILDER.JSON_SCHEMA_PREVIEW')}
          </Text>
          <Button variant="subtle" size="xs" onClick={handleCopySchema}>
            {t('JSON_SCHEMA_BUILDER.COPY')}
          </Button>
        </Flex>
        <ScrollArea style={{ flex: 1 }}>
          <Code block style={{ fontSize: '12px', overflowWrap: 'break-word', wordBreak: 'break-word' }}>
            {schemaJsonString}
          </Code>
        </ScrollArea>
      </Box>
    </Box>
  );
}
